export const EMPTY_OBJECT = Object.freeze( {} );
export const EMPTY_ARRAY = Object.freeze( [] );
